import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  offerPrice: {
    id: 't.offerPrice',
    defaultMessage: '{price} + tax/{frequency}',
  },
  reviewYourChange: {
    id: 't.reviewYourChange',
    defaultMessage: 'Review your change',
  },
  youAreChangingTo: {
    id: 't.youAreChangingTo',
    defaultMessage: 'You are changing your subscription to:',
  },
});
